import { useOperators, OperatorType } from "mingo/core";
import { $ne, $gte, $gt, $lte, $lt, $in, $regex, $or, $and, $nor, $exists } from "mingo/operators/query";

export const MingoAllowedOperators = ['ne', 'gte', 'gt', 'lte', 'lt', 'in', 'regex', 'regexp', 'or', 'and', 'nor', 'exists'];

useOperators(OperatorType.QUERY, { $ne, $gte, $gt, $lte, $lt, $in, $regex, $or, $and, $nor, $exists });